export default __webpack_public_path__ + "cc0f433232c6013a477a0b4b8ed4fc97.woff";